module.exports = __webpack_public_path__ + "static/media/b4-black-spanish.4c33ed4d.png";